// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"976aae30","502":"c3a71a48","3545":"2c90259a","4129":"976aae30","4313":"976aae30"}[chunkId] + ".chunk.css";
};